import React from 'react'
import classnames from 'classnames'

const OnboardTitle = ({ className, children }) => {
  return <h1 className={classnames('s1 text-white', className)}>{children}</h1>
}

export default OnboardTitle
